
















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Parts extends Vue {
  @Prop({ type: Boolean, required: true })
  public visibility!: boolean;
}
